/*
 * File: KeyDeals.tsx
 * Project: a-a
 * File Created: Wednesday, 8th January 2025 9:41:12 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Thursday, 16th April 2026 9:32:42 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import {
  Box,
  Chip,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Stack,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import CustomCard from '../../CustomCard/CustomCard';
import { Link, useLocation, useParams } from 'react-router-dom';
import zeplinColor from '../../../../theme/Color';
import KeyDealsCard from '../Overview/KeyDealsCard/KeyDealsCard';
import KeyDealsDetail from './KeyDealsDetail';
import CustomButton from '../../CustomButton/CustomButton';
import { ClientService } from '../../../../service/client.service';
import CustomLoader from '../../CustomLoader/CustomLoader';
import { LightTooltip } from '../../CustomTooltip/CustomTooltip';
import CustomModal from '../../CustomModal/CustomModal';
import CustomPopOver from '../../CustomPopOver/CustomPopOver';
import CustomDealForm from './CustomDealForm';
import CustomAlert from '../../CustomAlert/CustomAlert';
import CustomAlertContain from '../../CustomAlert/CustomAlertContain';
import CustomChip from '../../CustomChip/CustomChip';
import { get } from 'http';
import styles from './KeyDealsTab.module.css';
import { HuddleClientService } from '../../../../service/huddle-client.service';
type DealType = {
  accountId: string;
  name: string;
  accountName: string;
  stageName: string;
  amount: string | null;
  clientRevenue: string | null;
  companyRevenue: string | null;
  commitments: string | null;
  closeDate: string | null;
  lastModifiedByName: string | null;
  lastModifiedDate: string | null;
  createdByName: string | null;
  createdDate: string | null;
  ownerName: string | null;
  probability: number | null;
  type: string | null;
  iqScore: number | null;
  opportunityType: string | null;
  termStart: string | null;
  termEnd: string | null;
  dealId: string | null;
  exclusivity: string | null;
  category: string | null;
  leadSource: string | null;
  reasonLost: string | null;
  partnerPercent: string | null;
  estimatedValuation: string | null;
  products: any[];
  Name: string | null;
  Quantity: string | number | null;
  UnitPrice: string | number | null;
  commission: string | null;
  rate: string | null;
  dealSource: string | null;
  campaignName: string | null;
  gdEquity: boolean | null;
  Partner_Payout__c: string | null;
  exclusivityLanguage: string | null;
  compensation: string | null;
  services: string | null;
  productionStatus: string | null;
  arena: string | null;
  genre: string | null;
  options: string | null;
  conditions: string | null;
  executiveProducerServices: string | null;
  logLine: string | null;
  recoupability: string | null;
  executiveProducerFee: string | null;
  conditionsFees: string | null;
  magr: string | null;
  Guarantee__c: string | null;
  releaseType: string | null;
  rating: string | null;
  role: string | null;
  approxShootDateStart: string | null;
  approxShootDateEnd: string | null;
  episodicOrder: string | null;
};
const KeyDealsTab = ({ getDeal }: { getDeal: () => Promise<void> }) => {
  const location = useLocation();
  const sf_token = sessionStorage.getItem('SFToken') || '';
  const dealSelectedFromOverview = sessionStorage.getItem('dealSelectedFromOverview') || '';
  const selectedDeal = sessionStorage.getItem('selectedDeal') || {};
  const deleteDeal = sessionStorage.getItem('deleteDeal') || {};
  const activeDealTab = sessionStorage.getItem('activeDealTab') || '';
  const sf_redirect = sessionStorage.getItem('sf_redirect') || '';
  let parse_sf = {
    access_token: '',
    id: '',
    instance_url: '',
    issued_at: '',
    refresh_token: '',
    scope: '',
    signature: '',
    token_type: '',
  };
  if (sf_token) {
    parse_sf = JSON.parse(sf_token);
  }
  const screenHeight = window.innerHeight;
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [details, setDetails] = React.useState<DealType[]>([
    {
      accountId: '',
      name: '',
      accountName: '',
      stageName: '',
      amount: null,
      clientRevenue: null,
      companyRevenue: null,
      commitments: null,
      closeDate: null,
      lastModifiedByName: null,
      lastModifiedDate: null,
      createdByName: null,
      createdDate: null,
      ownerName: null,
      probability: null,
      type: null,
      iqScore: null,
      opportunityType: null,
      dealId: null,
      termStart: null,
      termEnd: null,
      exclusivity: null,
      category: null,
      leadSource: null,
      reasonLost: null,
      partnerPercent: null,
      estimatedValuation: null,
      products: [],
      Name: null,
      Quantity: null,
      UnitPrice: null,
      commission: null,
      rate: null,
      dealSource: null,
      campaignName: null,
      gdEquity: null,
      Partner_Payout__c: null,
      exclusivityLanguage: null,
      compensation: null,
      services: null,
      productionStatus: null,
      arena: null,
      genre: null,
      options: null,
      conditions: null,
      executiveProducerServices: null,
      logLine: null,
      recoupability: null,
      executiveProducerFee: null,
      conditionsFees: null,
      magr: null,
      Guarantee__c: null,
      releaseType: null,
      rating: null,
      role: null,
      approxShootDateStart: null,
      approxShootDateEnd: null,
      episodicOrder: null,
    },
  ]);
  const [selected, setSelected] = React.useState<DealType>();
  const [taskAnchorEl, setTaskAnchorEl] = React.useState<HTMLDivElement | null>(null);
  const [dealFilterAnchorEl, setDealFilterAnchorEl] = React.useState<HTMLDivElement | null>(null);
  const [modalOpen, setModalOpen] = React.useState(false);
  const [confirmModal, setConfirmModal] = React.useState(false);
  const openTask = Boolean(taskAnchorEl);
  const openDealFilter = Boolean(dealFilterAnchorEl);
  const [message, setMessage] = useState('');
  const idTask = openTask ? 'simple-popover' : undefined;
  const idDealFilter = openDealFilter ? 'simple-popover' : undefined;
  const [activeChip, setActiveChip] = useState<string[]>([]); // Track if the chip is active
  const [recordType, setRecordType] = useState<any>({});

  const [selectedItems, setSelectedItems] = useState<{
    priority: string[];
    status: string[];
    time: string[];
    client: string[];
    recordTypes: string[];
  }>({
    priority: [],
    status: [],
    time: [],
    client: [],
    recordTypes: [],
  });

  const getRecordType = async () => {
    try {
      setLoading(true);
      const res = await ClientService.getDealType();
      setRecordType(res);
    } catch (err) {
      // setError(true);
      setMessage('Something went wrong');
    } finally {
      setLoading(false);
    }
  };
  const handleClearAll = () => {
    setSelectedItems({
      priority: [],
      status: [],
      time: [],
      client: [],
      recordTypes: [],
    });
    setActiveChip([]);
    setDealFilterAnchorEl(null);
    getKeyDeals(params?.id || '', {});
  };
  const handleDealCreateClick = (event: React.MouseEvent<HTMLDivElement>, onlyAnchor?: boolean) => {
    if (sf_token === 'true' || location?.pathname?.includes('huddle')) {
      onlyAnchor ? setConfirmModal(true) : setModalOpen(true);
    } else {
      setTaskAnchorEl(event.currentTarget);
    }
    // onlyAnchor && setTaskAnchorEl(event.currentTarget);
  };
  const getKeyDeals = async (id: string, query?: any) => {
    setLoading(true);
    try {
      setDealFilterAnchorEl(null);
      if (id) {
        let res;
        if (location?.pathname?.includes('huddle')) {
          res = await HuddleClientService.getHuddleClientKeyDeals(
            id,

            query || {
              ...(activeChip?.length && {
                opportunityType: activeChip.map((val: string) => val.split(' ')[0]),
              }),
              ...(selectedItems?.time?.[0] === 'overdue' && { isOverdue: true }),
              ...(selectedItems?.time?.[0] === 'closeDate' && { sortBy: selectedItems?.time?.[0] }),
            },
          );
        } else {
          res = await ClientService.getClientKeyDeals(
            id,
            query || {
              ...(activeChip?.length && {
                opportunityType: activeChip.map((val: string) => val.split(' ')[0]),
              }),
              ...(selectedItems?.time?.[0] === 'overdue' && { isOverdue: true }),
              ...(selectedItems?.time?.[0] === 'closeDate' && { sortBy: selectedItems?.time?.[0] }),
            },
          );
        }
        const deals = res?.key_deals;

        if (deals) {
          selectedItems?.time?.[0] || activeChip?.length
            ? setSelected(deals[0])
            : setSelected(
                dealSelectedFromOverview
                  ? deals?.filter((val: any) => val?.dealId === dealSelectedFromOverview)[0]
                    ? deals?.filter((val: any) => val?.dealId === dealSelectedFromOverview)[0]
                    : deals[0]
                  : deals[0],
              );
          setDetails(deals);
          (selectedItems?.time?.[0] || activeChip?.length) &&
            sessionStorage.setItem('dealSelectedFromOverview', '0');
        } else {
          setDetails([]);
        }
      }
    } catch (err: any) {
      // console.log(err, 'errdeal');
      setMessage('Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    try {
      setLoading(true);
      let res;
      if (location?.pathname?.includes('huddle')) {
        res =
          selected?.dealId &&
          (await HuddleClientService.deleteHuddleDeal(selected?.dealId || '', {
            // data: { access_token: parse_sf.access_token },
          }));
      } else {
        res =
          selected?.dealId &&
          (await ClientService.deleteDeal(selected?.dealId || '', {
            // data: { access_token: parse_sf.access_token },
          }));
      }
      setConfirmModal(false);
      await getKeyDeals(params?.id || '');
      await getDeal();

      setMessage('Deal deleted successfully');
      sessionStorage.removeItem('deleteDeal');
      sessionStorage.removeItem('dealSelectedFromOverview');
      sessionStorage.removeItem('sf_path');
      sessionStorage.removeItem('sf_redirect');
    } catch (err: any) {
      setMessage('Something went wrong');
    } finally {
      setLoading(false);
    }
  };
  const handleClickChip = (val: string) => {
    const unique = activeChip.filter((valRef: string) => val === valRef);
    // console.log(unique, activeChip);
    setActiveChip((prev: string[]) =>
      unique?.length ? prev.filter((valRef: string) => val !== valRef) : [...prev, val],
    ); // Toggle the active state on click
  };
  const handleCloseConfirm = () => {
    sessionStorage.removeItem('sf_path');
    sessionStorage.removeItem('sf_redirect');
    sessionStorage.removeItem('deleteDeal');
    setConfirmModal(false);
  };
  const handleClose = () => {
    setMessage('');
  };
  useEffect(() => {
    if (message?.includes('successfully') && !modalOpen) {
      getKeyDeals(params?.id || '');
      getDeal();
    }
  }, [modalOpen]);

  useEffect(() => {
    getKeyDeals(params?.id || '');
    getDeal();
    getRecordType();
    if (sf_redirect) {
      if (typeof deleteDeal === 'string') {
        setConfirmModal(true);
        return;
      }
      setModalOpen(true);
    }
  }, [sf_redirect]);

  useEffect(() => {
    if (dealSelectedFromOverview) {
      const container = document.getElementById('deals-scroll-container');
      const el = document.getElementById(`deal-${dealSelectedFromOverview}`);
      if (el && container) {
        // Scroll only the container, not the whole page
        const elTop = el.offsetTop;
        container.scrollTo({
          top: elTop - container.offsetTop,
          behavior: 'smooth',
        });
      }
    }
  }, [details, dealSelectedFromOverview]);

  return (
    <>
      {' '}
      {details?.length ? (
        <LightTooltip
          title={
            <Typography variant='responsiveBody3' color={zeplinColor.Neutral1}>
              New deal
            </Typography>
          }
          placement='bottom-end'
          style={{
            backgroundColor: zeplinColor.BasicBlack,
            borderRadius: '8px',
          }}
        >
          <Box sx={{}}>
            <CustomButton
              disabled={false}
              onClick={handleDealCreateClick}
              variant='contained'
              color={'primary'}
              buttonVariant='responsiveButtonLarge'
              style={{
                // width: '100%',
                borderRadius: { xs: '10px', xl: '14px' },
                height: { xs: 30, xl: 48 },
                padding: { xs: '10px 12px', xl: '14px 16px' },
                position: 'absolute',
                top: '0px',
                right: '0px',
                '&.Mui-focusVisible': { backgroundColor: '#333CAA' },
              }}
              textStyle={{ color: zeplinColor.Neutral1 }}
              text={'New Deal'}
              icon={<img src={`/assets/add-white.svg`} className={styles['add-icon']} />}
              // tabindex={4}
            />
          </Box>
        </LightTooltip>
      ) : (
        ''
      )}
      {!loading && !details?.length ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: 'calc(100vh - 380px)', // Match the height of your content area
            width: '100%',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              flex: 1,
              height: '100%',

              gap: { xs: '20px', xl: '32px' },
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                // flex: 1,
                gap: { xs: '6px', xl: '12px' },
              }}
            >
              <img src={'/assets/no-keydeals.svg'} className={styles['no-deal-icon']} />
              <Typography variant='responsiveHeading3' color={zeplinColor.BasicBlack}>
                {activeChip?.length || selectedItems?.time?.[0]
                  ? 'No Deals Available'
                  : 'No Deals Available'}
              </Typography>
              {activeChip?.length || selectedItems?.time?.[0] ? (
                <Typography
                  variant='responsiveBody3'
                  color={zeplinColor.Neutral8}
                  sx={{ textAlign: 'center' }}
                >
                  Change your filters to see deals.
                </Typography>
              ) : (
                <Typography
                  variant='responsiveBody3'
                  color={zeplinColor.Neutral8}
                  sx={{ textAlign: 'center' }}
                >
                  Create new deals to keep track of client
                  <br /> opportunities and activities.
                </Typography>
              )}
            </Box>

            <CustomButton
              disabled={false}
              onClick={
                activeChip?.length || selectedItems?.time?.[0]
                  ? () => {
                      setSelectedItems({
                        priority: [],
                        status: [],
                        time: [],
                        client: [],
                        recordTypes: [],
                      });
                      setActiveChip([]);
                      getKeyDeals(params?.id || '', {});
                    }
                  : (e: any) => {
                      handleDealCreateClick(e);
                    }
              }
              variant='outlined'
              color='secondary'
              style={{
                // width: '40%',
                borderRadius: '14px',
                height: 56,
                backgroundColor: zeplinColor.Brand1,

                // gap: '16px',
                padding: '14px 16px',
              }}
              textStyle={{ color: zeplinColor.Neutral1 }}
              text={
                activeChip?.length || selectedItems?.time?.[0] ? 'Change Filters' : 'Create Deals'
              }
            />
          </Box>
        </Box>
      ) : loading || !selected?.dealId ? (
        <>
          <Box sx={{ display: 'flex', gap: '20px', marginTop: '20px' }}>
            <Box sx={{ flex: 1, display: 'flex', gap: '16px', flexDirection: 'column' }}>
              {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((val: any, ind: number) => (
                <KeyDealsCard key={val} data={details[0]} loading={true} />
              ))}
            </Box>
            <Box sx={{ flex: 2, height: '100%' }}>
              <KeyDealsDetail
                key={selected?.accountId}
                data={selected}
                loading={true}
                setConfirmModal={setConfirmModal}
                handleDealCreateClick={handleDealCreateClick}
                setMessage={setMessage}
              />
            </Box>
          </Box>
        </>
      ) : details.length && !loading && selected?.dealId ? (
        <>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                flex: 1,
                width: '100%',
              }}
            >
              <Typography variant='responsiveHeading3'>Deals</Typography>

              <img
                src='/assets/filter-deal.svg'
                className={styles['filterIcon']}
                style={{ cursor: 'pointer' }}
                alt='Filter'
                onClick={(e) => setDealFilterAnchorEl(e.currentTarget)}
              />
            </Box>
            <Box sx={{ display: 'flex', gap: '8px', flex: 2 }}></Box>
          </Box>
          <Box sx={{ display: 'flex', gap: '20px', marginTop: '20px' }}>
            <Box
              sx={{
                flex: '1 0 0', // Set flex-basis to 0 and flex-grow to 1
                width: '33.333%', // Explicitly set to 1/3 of the container
                maxWidth: '33.333%', // Ensure it doesn't grow beyond 1/3
              }}
            >
              {' '}
              <Box
                sx={{
                  overflowY: 'scroll',
                  display: 'flex',
                  flexDirection: 'column',
                  width: '100%',
                  position: 'relative',
                  height: { xs: 'calc(100vh - 370px)', xl: 'calc(100vh - 420px)' },

                  gap: '16px',
                }}
              >
                <Box
                  sx={{
                    overflowY: 'auto',
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    position: 'relative',
                    height: { xs: 'calc(100vh - 370px)', xl: 'calc(100vh - 420px)' }, // or any fixed height you want
                    gap: { xs: '10px', xl: '16px' },
                  }}
                  id='deals-scroll-container' // <-- add an id for reference
                >
                  {details?.map((val: DealType, index: number) => (
                    <Box
                      onClick={() => setSelected(val)}
                      sx={{ cursor: 'pointer' }}
                      id={`deal-${val?.dealId || index}`}
                      key={val?.accountId}
                    >
                      <KeyDealsCard data={val} selected={selected} index={index} />
                    </Box>
                  ))}
                </Box>
                {/* </Box> */}
              </Box>
            </Box>
            <Box
              sx={{
                flex: '2 0 0', // Set flex-basis to 0 and flex-grow to 2
                width: '66.666%', // Explicitly set to 2/3 of the container
              }}
            >
              <KeyDealsDetail
                key={selected?.accountId}
                data={selected}
                setConfirmModal={setConfirmModal}
                handleDealCreateClick={handleDealCreateClick}
                setMessage={setMessage}
              />
            </Box>
          </Box>
        </>
      ) : (
        <></>
      )}
      <CustomModal handleClose={handleCloseConfirm} open={confirmModal}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
          }}
        >
          <CustomCard
            styles={{
              borderRadius: '14px',
              padding: '24px',
              backgroundColor: zeplinColor.Neutral1,

              width: '312px',
              // height: '201px',
              boxShadow: 'rgba(0, 0, 0, 0.15)',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '32px',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '16px',
                }}
              >
                <Typography variant='heading3' color={zeplinColor.BasicBlack}>
                  Delete Deal?
                </Typography>
                <Typography variant='body2' color={zeplinColor.BasicBlack}>
                  Are you sure you want to delete this deal? This action cannot be undone.
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',

                  gap: '16px',
                }}
              >
                <Box
                  onClick={handleCloseConfirm}
                  sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}
                >
                  <CustomCard
                    styles={{
                      borderRadius: '14px',
                      padding: '14px 32px',
                      backgroundColor: zeplinColor.Neutral1,
                      border: `1px solid ${zeplinColor.BasicBlack}`,
                      cursor: 'pointer',

                      display: 'flex',
                      justifyContent: 'center',
                      flex: 1,
                    }}
                    aria-role='button'
                    aria-disable={loading}
                  >
                    <Typography variant='buttonMedium' color={zeplinColor.BasicBlack}>
                      Cancel
                    </Typography>
                  </CustomCard>
                </Box>
                <Box
                  onClick={
                    loading
                      ? () => {}
                      : () => {
                          handleDelete();
                        }
                  }
                  sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}
                >
                  <CustomCard
                    styles={{
                      borderRadius: '14px',
                      padding: '14px 32px',
                      backgroundColor: loading ? zeplinColor.Neutral8 : zeplinColor.Error,
                      cursor: 'pointer',

                      display: 'flex',
                      justifyContent: 'center',
                      flex: 1,
                    }}
                    aria-role='button'
                    aria-disable={loading}
                  >
                    <Typography
                      variant='buttonMedium'
                      color={zeplinColor.Neutral1}
                      sx={{ whiteSpace: 'nowrap', textAlign: 'center' }}
                    >
                      Delete
                    </Typography>
                  </CustomCard>
                </Box>
              </Box>
            </Box>
          </CustomCard>
        </Box>
      </CustomModal>
      <CustomPopOver
        setAnchorEl={setTaskAnchorEl}
        anchorEl={taskAnchorEl}
        id={idTask}
        sx={{
          borderRadius: '14px',
          boxShadow: 'rgba(0, 0, 0, 0.15)',
          marginTop: '8px',
          // marginRight: '2rem',
          // marginLeft: '-4rem',
        }}
      >
        <Box
          sx={{
            width: { xs: '300px', xl: '340px' },
            padding: { xs: '18px', xl: '24px' },
            display: 'flex',
            gap: '32px',
            flexDirection: 'column',
          }}
        >
          <Box sx={{ display: 'flex', gap: '16px', flexDirection: 'column' }}>
            <Box sx={{ display: 'flex', gap: '12px', justifyContent: 'space-between' }}>
              <Typography variant='responsiveHeading3' color={zeplinColor.BasicBlack}>
                Authentication Required
              </Typography>
              <img
                src={'/assets/close-icon.svg'}
                className={styles['icon-24']}
                alt='close'
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  setTaskAnchorEl(null);
                }}
              />
            </Box>

            <Typography variant='responsiveBody3' color={zeplinColor.BasicBlack}>
              {/* To create/edit a Deal, please ensure you're logged in to your Salesforce account. */}
              You need to be logged into Salesforce to perform this action. Please log in to your
              Salesforce account.
            </Typography>
          </Box>
          <Link
            // target='_blank'
            // rel='noopener noreferrer'
            to={`https://${process.env.REACT_APP_SALESFORCE_URI}/services/oauth2/authorize?client_id=${process.env.REACT_APP_CLIENT_SALESFORCE}&redirect_uri=${process.env.REACT_APP_REDIRECT}&response_type=code`}
          >
            <CustomButton
              disabled={false}
              onClick={() => {
                sessionStorage.setItem('sf_redirect', 'Deals');
                sessionStorage.setItem('sf_path', location?.pathname);
              }}
              variant='contained'
              buttonVariant='responsiveButtonLarge'
              color={'primary'}
              style={{
                width: { xs: '125px', xl: '155px' },
                borderRadius: { xs: '12px', xl: '14px' },
                height: { xs: '38px', xl: '48px' },

                padding: '14px 16px',
                '&.Mui-focusVisible': { backgroundColor: '#333CAA' },
              }}
              textStyle={{ color: zeplinColor.Neutral1 }}
              text={'Open Salesforce'}
              // tabindex={4}
            />
          </Link>
        </Box>
      </CustomPopOver>
      <CustomPopOver
        setAnchorEl={setDealFilterAnchorEl}
        anchorEl={dealFilterAnchorEl}
        id={idDealFilter}
        sx={{
          borderRadius: '14px',
          boxShadow: 'rgba(0, 0, 0, 0.15)',
          marginTop: '8px',
          // marginRight: '2rem',
          // marginLeft: '-4rem',
        }}
      >
        <Box
          sx={{
            // height: '383px',
            width: '295px',
            padding: '16px',
            display: 'flex',
            gap: '16px',
            flexDirection: 'column',
            // overflowY: 'scroll',
          }}
        >
          {' '}
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography variant='heading3' color={zeplinColor.BasicBlack}>
              Sort by
            </Typography>
            <Typography
              variant='buttonSmall'
              color={
                Object.values(selectedItems).every((val) => val.length <= 0) &&
                activeChip.length <= 0
                  ? zeplinColor.Neutral8
                  : zeplinColor.Brand1
              }
              onClick={
                Object.values(selectedItems).every((val) => val.length <= 0) &&
                activeChip.length <= 0
                  ? () => {
                      return;
                    }
                  : handleClearAll
              }
              sx={{
                cursor:
                  Object.values(selectedItems).every((val) => val.length <= 0) &&
                  activeChip.length <= 0
                    ? 'default'
                    : 'pointer',
              }}
            >
              Clear All
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <Typography variant='body3' color={zeplinColor.Neutral8}>
              Date
            </Typography>
            <FormControl>
              <RadioGroup
                aria-labelledby='demo-radio-buttons-group-label'
                defaultValue='N/A'
                name='radio-buttons-group'
                onChange={(e) => {
                  setSelectedItems((prev) => ({
                    ...prev,
                    time: e.target.value ? [e.target.value] : [],
                  }));
                }}
              >
                <FormControlLabel
                  value='closeDate'
                  control={
                    <Radio
                      sx={{
                        color: zeplinColor.BasicBlack,
                        '&.Mui-checked': {
                          color: zeplinColor.BasicBlack,
                        },
                      }}
                      checked={selectedItems?.time?.[0] === 'closeDate'}
                    />
                  }
                  label='Close Date'
                />
                <FormControlLabel
                  value='overdue'
                  control={
                    <Radio
                      sx={{
                        color: zeplinColor.BasicBlack,
                        '&.Mui-checked': {
                          color: zeplinColor.BasicBlack,
                        },
                      }}
                      checked={selectedItems?.time?.[0] === 'overdue'}
                    />
                  }
                  label='Overdue Deal'
                />
              </RadioGroup>
            </FormControl>
          </Box>
          <Divider component='div' sx={{ borderColor: zeplinColor.Neutral5 }} />
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <Typography variant='body3' color={zeplinColor.Neutral8}>
              Type
            </Typography>
            <Box sx={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
              {Object.keys(recordType).length > 0 &&
                Object.keys(recordType).map((val: string) => (
                  <Chip
                    key={val}
                    label={val}
                    variant='outlined'
                    sx={{
                      borderColor: activeChip.includes(val)
                        ? zeplinColor.BasicBlack
                        : zeplinColor.Neutral5,
                      backgroundColor: activeChip.includes(val)
                        ? zeplinColor.BasicBlack
                        : zeplinColor.Neutral1,
                      color: activeChip.includes(val)
                        ? zeplinColor.Neutral1
                        : zeplinColor.BasicBlack,
                      '&.MuiChip-root.MuiChip-clickable:hover': {
                        borderColor: activeChip.includes(val)
                          ? zeplinColor.BasicBlack
                          : zeplinColor.Neutral5,
                        backgroundColor: activeChip.includes(val)
                          ? zeplinColor.BasicBlack
                          : zeplinColor.Neutral1,
                        color: activeChip.includes(val)
                          ? zeplinColor.Neutral1
                          : zeplinColor.BasicBlack,
                      },
                      fontSize: '12px',
                    }}
                    onClick={() => handleClickChip(val)}
                  />
                ))}
            </Box>
          </Box>
          <CustomButton
            disabled={activeChip?.length <= 0 && selectedItems?.time?.length <= 0}
            onClick={getKeyDeals.bind(null, params?.id || '', '')}
            variant='contained'
            color={'primary'}
            style={{
              // width: '100%',
              borderRadius: '14px',
              height: 48,
              padding: '14px 16px',
              // position: 'absolute',
              // top: '0px',
              // right: '0px',
              '&.Mui-focusVisible': { backgroundColor: '#333CAA' },
            }}
            textStyle={{ color: zeplinColor.Neutral1 }}
            text={'Apply'}
            // icon={<img src={`/assets/add-white.svg`} width={'13.3px'} height={'13.3px'} />}
            // tabindex={4}
          />
        </Box>
      </CustomPopOver>
      {modalOpen ? (
        <CustomDealForm
          setOpen={setModalOpen}
          key={modalOpen.toString() || selected?.dealId}
          setDealMessage={setMessage}
          selectedDeal={selectedDeal || {}}
          activeDealTab={activeDealTab || '0'}
          setTaskAnchorEl={setTaskAnchorEl}
          sf_token={sf_token}
        />
      ) : (
        ''
      )}
      <CustomAlert
        open={message ? true : false}
        handleClose={handleClose}
        message={
          <CustomAlertContain
            alertIcon={
              message?.includes('wrong') ? (
                <img src='/assets/error.svg' width={24} height={24} />
              ) : (
                <img src='/assets/checkmark-green.png' width={24} height={24} />
              )
            }
            alert={message}
          />
        }
        error={message?.includes('wrong')}
      />
    </>
  );
};

export default KeyDealsTab;
